import NavigableValidator from "./navigableValidator";
import {ValidationErrorMessage} from "~/enums/validationErrorMessage";
import ValidationError from "../validationError";
import {ErrorType} from "~/enums/ErrorType";
import DetailViewContentElement from "~/models/detailView/elements/detailViewContentElement";
import {RelationSection} from "../../../formability/detailViewBuilder/models/relationSection";
import ObjectModel from "~/models/objectModel";

export default class RelationSectionLinkedDetailViewsValidator extends NavigableValidator<DetailViewContentElement> {
  _validatorKey = 'relation_section_linked_detail_views';
  defaultMessage = ValidationErrorMessage.MustBePresent;
  defaultType = ErrorType.mustBePresent;

  protected _validate(model: RelationSection): void {
    if (!model.link_to_view_selected) return;
    const linkedDetailViews = model.relation_section_linked_detail_views;
    const relation: any = model.relation;
    const detailViewObjectModelIds = Object.keys(linkedDetailViews).map(clientId => linkedDetailViews[clientId].related_object_model_id);

    if (relation.inverse) {
      const objectModelId = relation.object_model_id;
      if (!detailViewObjectModelIds.includes(objectModelId)) {
        const objectModel = model.parent.objectModel.allRelatedAndInverseRelatedObjectModels.find(om => om.id === objectModelId);
        const error = this.buildValidationError(model, relation, objectModel);
        this.errors.push(error);
      }
    } else {
      const objectModelIds = relation.related_object_model_ids;
      for (const objectModelId of objectModelIds) {
        if (!detailViewObjectModelIds.includes(objectModelId)) {
          const objectModel = model.parent.objectModel.allRelatedAndInverseRelatedObjectModels.find(om => om.id === objectModelId);
          const error = this.buildValidationError(model, relation, objectModel);
          this.errors.push(error);
        }
      }
    }
  }

  buildValidationError(model: RelationSection, relation: any, objectModel: ObjectModel,  message?): ValidationError {
    const validationError = super.buildValidationError(model, relation)
    const errorNavOpts = model.validation.errorNavOpts(this, this.validatorKey)
    const targetElementId = `relation_section_detail_view_${objectModel.id}`

    Object.assign(errorNavOpts, {
      targetElementId: targetElementId
    })
    Object.assign(validationError, {
      displayName: `Relation Section: Detail View for ${objectModel.title}`,
      errorNavOpts: errorNavOpts,
      field: targetElementId,
    })
    if (message)  {
      Object.assign(validationError, {
        message: message
      })
    }
    return validationError;
  }
}

